import { createStyles, makeStyles } from '@material-ui/styles'
import colors from 'shared/style/colors'

import { Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      position: 'relative',
      boxShadow: `0.06rem 0.06rem 0.2rem ${colors.highlightable}`
    },
    mobileStretch: {
      width: '100vw',
      position: 'relative',
      left: 'calc(-50vw + 50%)'
    },
    description: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      position: 'absolute',
      bottom: '0%',
      height: '50%',
      width: '100%',
      // A CONSERVER -------------------->
      // background: 'transparent linear-gradient(180deg, #00000000 0%, #000000CC 100%) 0% 0% no-repeat padding-box',
      // A CONSERVER <--------------------
      '& p.light': {
        color: `${colors.white} !important`
      },
      '& p.dark': {
        color: `${colors.black} !important`
      },
      '& p': {
        padding: '0 2rem',
        margin: '0'
      }
    },
    title: {
      fontSize: '3rem',
      fontWeight: 'bold',
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.8rem'
      }
    },
    text: {
      fontSize: '1.4rem',
      [theme.breakpoints.down('xs')]: {
        fontSize: '1rem'
      }
    },

    swiperButton: {
      position: 'absolute',
      top: 0,
      width: '10%',
      height: '100%',
      zIndex: 10,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      '&.nav-prev': {
        left: 0,
        right: 'auto',
        justifyContent: 'flex-start',
        paddingLeft: '0.5rem',
        '& img': {
          left: '0.375rem'
        }
      },
      '&.nav-next': {
        right: 0,
        left: 'auto',
        justifyContent: 'flex-end',
        paddingRight: '0.5rem',
        '& img': {
          left: '0.5rem'
        }
      }
    },
    arrow: {
      width: '1.875rem',
      height: '1.875rem',
      position: 'relative',
      background: colors.white,
      boxShadow: `0.08rem 0.08rem 0.2rem ${colors.black}`,
      opacity: '0.25',
      borderRadius: '50%',
      '& img': {
        width: '0.9375rem',
        position: 'absolute',
        top: '0.5rem'
      }
    },
    slide: {
      cursor: 'pointer',
      height: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    slideWithoutLink: {
      cursor: 'default'
    },
    swiperPagination: {
      display: 'flex',
      justifyContent: 'center',
      width: '80%',
      margin: '0 10%',
      height: '0.5rem',
      position: 'absolute',
      bottom: '3%',
      zIndex: 2
    },
    pagination: {
      margin: '0 0.25rem',
      height: '0.3rem',
      background: colors.light,
      borderRadius: '0.1875rem',
      zIndex: 3
    },
    paginationActive: {
      background: colors.primary
    }
  })
)
